import React, { useState } from 'react';
import { Modal, Button, Table, Tabs, Tab, Badge } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import { formatDateTime } from '../../utils/dateHelpers';

const SalesOrdersOverview = ({ orders }) => {

    const [showItemModal, setShowItemModal] = useState(false);
    const [selectedItems, setSelectedItems] = useState(null);

    const handleItemClick = (items) => {
        setSelectedItems(items);
        setShowItemModal(true);
    };

    const OrdersTable = ({ items, category }) => (
        <div className="table-responsive">
            <table className="table table-hover">
                <thead>
                    <tr>
                        <th>SO Number</th>
                        {/* <th>Customer</th> */}
                        <th>Expected Delivery Date</th>
                        {/* <th>Total Amount</th> */}
                        <th>Status</th>
                        {category === 'inProduction' && <th>Production Batch</th>}
                        <th>Actions</th>
                    </tr>
                </thead>
                <tbody>
                    {items.length === 0 ? (
                        <tr>
                            <td colSpan={category === 'inProduction' ? '7' : '6'} className="text-center py-4">
                                <div className="text-muted">
                                    <i className="fas fa-inbox fa-2x mb-2"></i>
                                    <div>No {getCategoryLabel(category).toLowerCase()} orders found</div>
                                </div>
                            </td>
                        </tr>
                    ) : (
                        items.map(order => (
                            <tr key={order._id}>
                                <td>
                                    <div className="fw-bold">{order.orderNumber}</div>
                                    <small className="text-muted">{formatDateTime(order.createdAt)}</small>
                                </td>
                                {/* <td>
                                    <div>{order.buyer?.business_name || 'N/A'}</div>
                                    {order.broker && (
                                        <small className="text-muted">via {order.broker.business_name}</small>
                                    )}
                                </td> */}
                                <td>{formatDateTime(order.EDD)}</td>
                                {/* <td>₹{order.totalAmount?.toLocaleString() || 0}</td> */}
                                <td>
                                    <Badge bg={getStatusColor(order.status)}>
                                        {order.status}
                                    </Badge>
                                    <br/>
                                    <small 
                                        className="text-muted" 
                                        onClick={() => handleItemClick(order.items)} 
                                        style={{ cursor: 'pointer' }}
                                    >
                                        Items: {order.items?.length || 0}
                                    </small>
                                </td>
                                {category === 'inProduction' && (
                                    <td>
                                        {order.productionBatch ? (
                                            <div>
                                                <Badge bg="info">
                                                    {order.productionBatch.batchNumber}
                                                </Badge>
                                                <div>
                                                    <Badge bg={getBatchStatusColor(order.productionBatch.status)} className="mt-1">
                                                        {order.productionBatch.status}
                                                    </Badge>
                                                </div>
                                            </div>
                                        ) : 'N/A'}
                                    </td>
                                )}
                                <td>
                                    <Link 
                                        to={`/sales-orders/${order._id}`}
                                        className="btn btn-sm btn-outline-primary me-1"
                                    >
                                        View
                                    </Link>
                                    {order.productionBatch && (
                                        <Link 
                                            to={`/batch/${order.productionBatch._id}`}
                                            className="btn btn-sm btn-outline-info"
                                        >
                                            Batch
                                        </Link>
                                    )}
                                </td>
                            </tr>
                        ))
                    )}
                </tbody>
            </table>
        </div>
    );

    const getStatusColor = (status) => {
        switch (status) {
            case 'Created': return 'primary';
            case 'Confirmed': return 'info';
            case 'In Production': return 'warning';
            case 'Dispatched': return 'info';
            case 'Delivered': return 'success';
            case 'Cancelled': return 'danger';
            default: return 'secondary';
        }
    };

    const getBatchStatusColor = (status) => {
        switch (status) {
            case 'Planned': return 'secondary';
            case 'In Progress': return 'warning';
            case 'Completed': return 'success';
            case 'On Hold': return 'danger';
            default: return 'secondary';
        }
    };

    const getCategoryLabel = (category) => {
        switch (category) {
            case 'new': return 'New Orders';
            case 'inProduction': return 'In Production';
            case 'dispatched': return 'Dispatched';
            default: return 'Orders';
        }
    };

    return (
        <>
        <Tabs defaultActiveKey="new" className="mb-3">
            <Tab 
                eventKey="new" 
                title={
                    <span>
                        New Orders <Badge bg="primary" className="ms-1">{orders.new?.length || 0}</Badge>
                    </span>
                }
            >
                <OrdersTable items={orders.new || []} category="new" />
            </Tab>
            <Tab 
                eventKey="inProduction" 
                title={
                    <span>
                        In Production <Badge bg="warning" className="ms-1">{orders.inProduction?.length || 0}</Badge>
                    </span>
                }
            >
                <OrdersTable items={orders.inProduction || []} category="inProduction" />
            </Tab>
            <Tab 
                eventKey="dispatched" 
                title={
                    <span>
                        Dispatched <Badge bg="success" className="ms-1">{orders.dispatched?.length || 0}</Badge>
                    </span>
                }
            >
                <OrdersTable items={orders.dispatched || []} category="dispatched" />
            </Tab>
        </Tabs>
        {/* Items Modal */}
            <Modal show={showItemModal} onHide={() => setShowItemModal(false)}>
                <Modal.Header closeButton>
                    <Modal.Title>Order Items</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    {selectedItems && (
                        <Table hover>
                            <thead>
                                <tr>
                                    <th>Product Name</th>
                                    <th>Quantity</th>
                                    <th>Quality</th>
                                </tr>
                            </thead>
                            <tbody>
                                {selectedItems.map((item) => (
                                    <tr key={item._id}>
                                        <td>{item.product?.productName}</td>
                                        <td>{item.quantity} {item.unit}</td>
                                        <td>{item.quality}</td>
                                    </tr>
                                ))}
                            </tbody>
                        </Table>
                    )}
                </Modal.Body>
                <Modal.Footer>
                    <Button variant="secondary" onClick={() => setShowItemModal(false)}>
                        Close
                    </Button>
                </Modal.Footer>
            </Modal>
        </>
    );
};

export default SalesOrdersOverview;